export default "__VITE_ASSET__tc34Cc6l__"